import { Controller } from "@hotwired/stimulus"
import Editor from "../components/storage_unit_type_shape/Editor.svelte"
import { mount, unmount } from "svelte"

export default class extends Controller {
  static values = {
    storageUnitTypeJson: Object,
  }

  connect() {
    this.editor = mount(Editor, {
      target: this.element,
      props: {
        storageUnitType: this.storageUnitTypeJsonValue
      }
    })
  }

  disconnect() {
    unmount(this.editor)
  }
}
